var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 77,
    viewBox: "0 0 95 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.9825 26.9578C81.055 20.0753 77.185 14.0153 71.99 9.38281L60.495 20.8778C64.6875 24.2903 67.515 29.3128 68.03 34.9978V38.7678C68.095 38.7678 68.155 38.7478 68.22 38.7478C74.025 38.7478 78.75 43.4728 78.75 49.2778C78.75 55.0828 74.025 59.8103 68.22 59.8103C68.155 59.8103 68.095 59.7928 68.03 59.7903V59.8103H51.365H47.5V76.0603H68.03V76.0503C68.095 76.0503 68.155 76.0603 68.22 76.0603C82.9875 76.0603 95 64.0453 95 49.2803C95 39.9678 90.215 31.7578 82.9825 26.9578Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.3999 45.0337L48.1999 33.2337C48.1899 33.2212 48.1799 33.2112 48.1724 33.2012L36.3799 44.9937C36.3849 45.0062 36.3924 45.0187 36.3999 45.0337Z",
    fill: "#FFE082"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.3999 45.0337L48.1999 33.2337C48.1899 33.2212 48.1799 33.2112 48.1724 33.2012L36.3799 44.9937C36.3849 45.0062 36.3924 45.0187 36.3999 45.0337Z",
    fill: "#90CAF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 0C27.1675 0 10.625 16.5425 10.625 36.875C10.625 37.4575 10.685 38.025 10.7125 38.6H26.9625C26.915 38.03 26.875 37.4575 26.875 36.875C26.875 25.5025 36.1275 16.25 47.5 16.25C52.4225 16.25 56.945 17.99 60.495 20.8775L71.99 9.3825C65.47 3.5675 56.9025 0 47.5 0Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.7802 59.8095C26.7777 59.8095 26.7777 59.8095 26.7752 59.8095C25.2477 59.8095 23.8052 59.467 22.4952 58.877L10.7202 70.652C15.2027 74.0295 20.7527 76.0595 26.7752 76.0595C26.7777 76.0595 26.7777 76.0595 26.7802 76.0595H47.5002V59.8095H26.7802Z",
    fill: "#90CAF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7802 59.8095C26.7777 59.8095 26.7777 59.8095 26.7752 59.8095C25.2477 59.8095 23.8052 59.467 22.4952 58.877L10.7202 70.652C15.2027 74.0295 20.7527 76.0595 26.7752 76.0595C26.7777 76.0595 26.7777 76.0595 26.7802 76.0595H47.5002V59.8095H26.7802Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 49.2848C16.25 43.4848 20.975 38.7598 26.775 38.7598C31.0325 38.7598 34.72 41.3173 36.3775 44.9948L48.17 33.2023C43.2675 26.6973 35.5075 22.5098 26.7725 22.5098C12.025 22.5098 0 34.5098 0 49.2848C0 58.0123 4.2275 65.7598 10.72 70.6523L22.495 58.8773C18.825 57.2323 16.25 53.5573 16.25 49.2848Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 104.875,
    y1: 40.4353,
    x2: 48.625,
    y2: 44.1853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AA4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 49.5875,
    y1: 5.08,
    x2: 33.57,
    y2: 29.2825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7572F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#F7552D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#F75026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#F7461B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#F7390A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F73100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 65.7627,
    y1: 81.9269,
    x2: 8.88772,
    y2: 56.6144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CAF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#4AAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#43A94E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#38A14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#279648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#118844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 30.4,
    y1: 52.7898,
    x2: 5.7125,
    y2: 28.7273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#FFD645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FED43E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#FCCF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#FAC922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#F7C10C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BC00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcp);
export default __webpack_public_path__ + "static/media/gcp.1b20e46ec8505993c7f862d5a87cfa1b.svg";
export { ForwardRef as ReactComponent };